<!-- Единое представление связанной записи с просмотром и необязательным удалением связи -->
<template>
  <div
    class="base-related-record-card"
    :class="{ 'base-related-record-card--compact': compact }"
  >
    <BaseEntityLink
      class="base-related-record-card__content"
      :clickable="false"
      :title="title"
      :subtitle="subtitle"
    >
      <template #icon><AppIcon :name="icon" :size="18" /></template>
    </BaseEntityLink>

    <!-- Ссылка накрывает карточку целиком, а явные действия остаются поверх неё. -->
    <BaseViewIconButton
      v-if="to"
      class="base-related-record-card__view-link"
      :class="{ 'base-related-record-card__view-link--with-remove': removable }"
      :to="to"
      new-tab
      :title="viewTitle"
    />

    <div class="base-related-record-card__actions">
      <span
        v-if="to"
        class="base-related-record-card__view-space"
        aria-hidden="true"
      />
      <BaseDeleteIconButton
        v-if="removable"
        icon="close"
        :icon-size="16"
        :title="removeTitle"
        :disabled="disabled"
        @click="$emit('remove')"
      />
    </div>
  </div>
</template>
<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
export default {
  name: "BaseRelatedRecordCard",
  components: { AppIcon },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    icon: { type: String, required: true },
    to: { type: [Object, String], default: null },
    viewTitle: { type: String, default: "Открыть в новой вкладке" },
    removeTitle: { type: String, default: "Убрать связь" },
    removable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
  },
  emits: ["remove"],
};
</script>
<style scoped>
.base-related-record-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  padding: 6px 8px;
  border-radius: 6px;
  background: #f6f8fa;
}

.base-related-record-card--compact {
  display: inline-flex;
  align-self: flex-start;
  width: auto;
  max-width: 100%;
}

.base-related-record-card--compact .base-related-record-card__content {
  flex: 0 1 auto;
  width: auto;
}

.base-related-record-card__content {
  position: relative;
  z-index: 2;
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
  /* Контент остаётся над ссылкой, которая накрывает всю карточку. */
  pointer-events: none;
}

.base-related-record-card :deep(.base-related-record-card__view-link) {
  position: absolute;
  inset: 0;
  z-index: 1;
  justify-content: flex-end;
  width: auto;
  height: auto;
  padding: 0 8px;
}

.base-related-record-card :deep(.base-related-record-card__view-link--with-remove) {
  padding-right: 48px;
}

.base-related-record-card__actions {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  pointer-events: none;
}

.base-related-record-card__view-space {
  width: 35px;
  height: 35px;
  flex: 0 0 35px;
}

.base-related-record-card__actions :deep(.base-delete-icon-button) {
  pointer-events: auto;
}
</style>
